import React, { useCallback, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Calendar from '@/components/Icons/Calendar';

import s from './DatePicker.module.scss';
import Label from '../shared/Label';

export interface DatePickerProps {
  label: string;
  description?: string;
  hint?: string;
  placeholder?: string;
  required?: boolean;
  selected?: Date;
  onChange: (date: Date) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: string;
  value: string | Date | null;
  disabled?: boolean;
  fixed?: boolean;
  min?: Date;
  max?: Date;
}

const CustomDatePicker: React.FC<DatePickerProps> = ({
  label,
  description,
  disabled,
  hint,
  placeholder,
  required,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  fixed = true,
  min,
  max,
}) => {
  const [inputDate, setInputDate] = React.useState<Date | null>(null);

  const handleDateChange = (date: Date | null): void => {
    setInputDate(date);
  };

  const handleBlur = useCallback(() => {
    if (inputDate) {
      onChange(inputDate);
      onBlur?.();
    }
  }, [inputDate, onChange]);

  useEffect(() => {
    if (value) {
      const dateValue = new Date(value);
      setInputDate(dateValue);
    }
  }, [value]);

  return (
    <div className={s.dateWrapper}>
      <Label
        label={label}
        required={required}
        description={description}
        errorMessage={error}
        hint={hint}
      >
        <div className={s.wrapper}>
          <DatePicker
            showIcon
            maxDate={max}
            minDate={min}
            showPopperArrow={false}
            selected={inputDate}
            onChange={handleDateChange}
            onFocus={onFocus}
            onBlur={handleBlur}
            placeholderText={placeholder}
            className={s.input}
            required={required}
            icon={<Calendar className={s.icon} />}
            disabled={disabled}
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            popperProps={fixed
              ? {
                strategy: 'fixed',
              }
              : undefined}
          />
        </div>
      </Label>
    </div>
  );
};

export default CustomDatePicker;
